// @ts-nocheck
import styled from 'styled-components';

export const TabsStyled = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
